"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Favorite_1 = __importDefault(require("@mui/icons-material/Favorite"));
var FavoriteBorder_1 = __importDefault(require("@mui/icons-material/FavoriteBorder"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var useShowVacancy_1 = __importDefault(require("./useShowVacancy"));
var Line_1 = __importDefault(require("../components/Line"));
var BookmarkedContext_1 = __importDefault(require("../context/BookmarkedContext"));
var classes = {
    tileContainer: {
        backgroundColor: '#fff',
        borderRadius: '5px',
        padding: '20px',
        overflow: 'hidden',
        position: 'relative',
        width: 'auto',
    },
    vacancyTitle: {
        marginTop: '2px',
        marginBottom: '12px',
        color: '#4b4b4b',
    },
    vacancySubTitle: {
        marginTop: '12px',
        color: '#4B4B4B',
    },
    organizationLogo: {
        width: 45,
        height: 45,
        '& > img': {
            objectFit: 'contain',
        },
    },
    referredLabel: {
        color: function (theme) { return theme.palette.primary.main; },
        marginBottom: 1,
    },
    jobLabel: {
        padding: 2,
        color: function (theme) { return theme.palette.primary.dark; },
        borderRadius: '10px',
        background: '#F4F2F4',
        textAlign: 'center',
    },
    saveVacancy: {
        position: 'absolute',
        top: '-10px',
        right: '-10px',
        padding: '16px',
        color: 'white',
        backgroundColor: function (theme) { return theme.palette.primary.main; },
        borderRadius: '50%',
        '&:hover': {
            backgroundColor: function (theme) { return theme.palette.primary.dark; },
        },
    },
};
var VacancyTile = function (_a) {
    var _b, _c, _d;
    var vacancy = _a.vacancy, selectedVacancyId = _a.selectedVacancyId;
    var isSmallScreen = (0, material_1.useMediaQuery)(function (theme) { return theme.breakpoints.down('md'); });
    var _e = (0, react_1.useContext)(BookmarkedContext_1.default), isLiked = _e.isLiked, handleToggleBookmark = _e.handleToggleBookmark;
    var showVacancy = (0, useShowVacancy_1.default)();
    var handleClickVacancy = (0, react_1.useCallback)(function () {
        showVacancy(vacancy.id, vacancy.slug);
    }, [showVacancy, vacancy.id]);
    var handleClickLike = (0, react_1.useCallback)(function (event) {
        event.stopPropagation();
        handleToggleBookmark(vacancy === null || vacancy === void 0 ? void 0 : vacancy.id);
    }, [vacancy === null || vacancy === void 0 ? void 0 : vacancy.id, handleToggleBookmark]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, container: true, sx: function (_a) {
            var palette = _a.palette;
            return (__assign(__assign({}, classes.tileContainer), { border: selectedVacancyId === vacancy.id ? "1px solid ".concat(palette.primary.main) : '1px solid #CDCDCD' }));
        }, onClick: handleClickVacancy }, { children: [vacancy.suggestedBy && ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, sx: classes.referredLabel }, { children: [trans_1.default.get('strings.frontend.application.suggested_by', { user: vacancy.suggestedBy }), (0, jsx_runtime_1.jsx)(Line_1.default, { backgroundColor: "#CDCDCD" })] }))), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(material_1.Avatar, { variant: "square", src: (_b = vacancy.organization) === null || _b === void 0 ? void 0 : _b.logo, alt: (_c = vacancy.organization) === null || _c === void 0 ? void 0 : _c.name, sx: classes.organizationLogo }) })), (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ sx: classes.saveVacancy, onClick: handleClickLike }, { children: isLiked(vacancy.id) ? (0, jsx_runtime_1.jsx)(Favorite_1.default, { fontSize: "large" }) : (0, jsx_runtime_1.jsx)(FavoriteBorder_1.default, { fontSize: "large" }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, sx: classes.vacancyTitle }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6", sx: { fontWeight: 'bold' } }, { children: (0, html_react_parser_1.default)(vacancy.title) })) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, item: true, gap: isSmallScreen ? 0 : 3, sx: { justifyContent: isSmallScreen ? 'space-between' : 'normal' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ sx: __assign(__assign({}, classes.jobLabel), { minWidth: isSmallScreen ? 90 : 50 }), item: true }, { children: vacancy.minimumHours === vacancy.maximumHours ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [vacancy.minimumHours, " uur"] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [vacancy.minimumHours, " - ", vacancy.maximumHours, " uur"] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ sx: __assign(__assign({}, classes.jobLabel), { minWidth: isSmallScreen ? 90 : 50 }), item: true }, { children: vacancy.minimumEducationalLevel.name })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ sx: __assign(__assign({}, classes.jobLabel), { minWidth: isSmallScreen ? 90 : 50 }), item: true }, { children: vacancy.contractType }))] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, sx: classes.vacancySubTitle }, { children: (0, jsx_runtime_1.jsxs)(material_1.Typography, { children: [(_d = vacancy.organization) === null || _d === void 0 ? void 0 : _d.name, " | ", vacancy.locationAddress] }) }))] })));
};
exports.default = VacancyTile;
